module.exports = __webpack_public_path__ + "static/img/cancelfullscreen.9e601b00.svg";